
import { Upload } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useToast } from "@/hooks/use-toast";

interface ImageUploadProps {
  onImageSelect: (file: File) => void;
}

const ImageUpload = ({ onImageSelect }: ImageUploadProps) => {
  const { t } = useTranslation();
  const { toast } = useToast();

  const handleImageSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      if (file.type !== "image/jpeg" && file.type !== "image/png") {
        toast({
          title: t("errors.invalidFileType"),
          description: t("errors.pleaseSelectImageFile"),
          variant: "destructive",
        });
        return;
      }
      onImageSelect(file);
    }
  };

  return (
    <input
      id="image-upload"
      type="file"
      accept="image/jpeg,image/png"
      className="hidden"
      onChange={handleImageSelect}
    />
  );
};

export default ImageUpload;
